import ContentBlocks from 'app/components/content-blocks/index';
import FilterStories from 'app/components/partials/filter-stories.container';
import formatContent from 'app/utilities/format-content';
import PropTypes from 'prop-types';
import { hasFeatureRow, LAYOUT } from 'app/utilities/news-listing';
import React, { Component } from 'react';

/**
 * Level 2 news category page, e.g. /news/conservation/marine
 */
class NewsSubCategory extends Component {
    render() {
        const { id, listingPage } = this.props;

        const {
            blocks = [],
            featured_news: featuredNews,
            intro_content: intro,
            name: title,
            short_description: description
        } = this.props.data;

        return (
            <div className="page || news-category-view">
                {/* The stories are what the page is for, so it opens on its
                    heading rather than on a banner: the featured ones below
                    carry the images instead. */}
                <header className="news-category-heading">
                    <div className="constrain-width large">
                        <h1 className="title">{title}</h1>
                        {description && <p className="subtitle">{description}</p>}
                    </div>
                </header>
                {/* Editor HTML, so it can link out to the animal and subcategory
                    pages behind the listing it introduces. */}
                {intro && (
                    <div className="news-category-intro">
                        <div className="constrain-width large">
                            <div
                                className="rich-editor-content"
                                dangerouslySetInnerHTML={{ __html: formatContent(intro) }} />
                        </div>
                    </div>
                )}
                {/* The deepest level of the tree, so there is nothing left to
                    filter by and the grid is all cards, three to a row. Stories
                    featured on the category open the row above it, taking the
                    first few of the listing along with them. */}
                <FilterStories
                    featuredNews={featuredNews}
                    /* The stories the row above shows are left out of the
                       listing, so the page does not run the same two headlines
                       twice. Only when the row is actually in use: a category
                       featuring some other number of them shows none of them
                       above, and holding them back would then be dropping
                       articles out of the chronology altogether. */
                    excludeFeatured={hasFeatureRow(featuredNews)}
                    layout={LAYOUT.GRID}
                    listingPage={listingPage}
                    pageCategoryId={id} />
                <ContentBlocks data={blocks} hasListing={true} />
            </div>
        );
    }
}

NewsSubCategory.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string,
    listingPage: PropTypes.number
};

export default NewsSubCategory;
